export const generateSystemId = (random = Math.random) =>
  String(Math.floor(1000000000 + random() * 9000000000));

export const ensureSystemId = (switchInfo, generate = generateSystemId) => {
  const systemId = switchInfo.sysId || switchInfo._randomId || generate();
  switchInfo._randomId = systemId;
  return systemId;
};
